<template>    
    <BaseModal
        :id="modal_name"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />

                <hr/>
                    <div class="modal-title w-100">
                        <h2 class="title--1" v-html="'Default project logic'"/>
                    </div>
                    <div class="modal__description">
                        <p class="modal__description__text" v-html="'Select a combination of Floor Type and Daily Task to define the default Project Task assignment for this room.'"/> 
                    </div>
    
                    <FormDynamic
                        :form_format="form_format2"
                        :form_data="form_data"
                        :array_options="array_options"
                        :for_update="false"
                    />
                <hr/>

                <div class="p-0 formdynamic__item col-md-auto">
                    <div class="formdynamic__item__field position-relative operator">
                        <label for="Time adjustment:" class="modal-label active" v-html="'Fixtures/Beds:'"/>
                        <button type="button" class="button__operator" v-html="'+'" @click="fixtureIncrement()"/>
                        <button type="button" class="button__operator" v-html="'-'" @click="fixtureDecrement()"/>
                        <input type="number" class="input__operator" :value="form_data.fixtures.length"/>
                    </div>
                </div>

                <div class="formdynamic__item col-md-6 py-0" v-for="(item, i) in form_data.fixtures" :key="i">
                    <div class="formdynamic__item__field">
                        <label for="Description:" class="modal-label" v-html="`Bed #${i+1}: <b style='color:red;'>*</b>`"/>
                        <input type="text" v-model="item.name" required/>
                    </div>
                </div>

                <LocalCentralButtons
                    :modal_name="modal_name"
                    :rooms_length="rooms_length !== undefined ? rooms_length : null"
                    :from_child="from_child"
                    :save_view="save_view"
                    @saveView="save_and_view($event)"
                />

            </form>
        </template>
    </BaseModal>
</template>

<script>

// import FormResources        from    './form_resources'
import FormDynamic          from    '@/components/FormDynamic.vue'
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import ChildFormResources   from    './ChildFormResources.js'
import BaseModal            from    '@/components/BaseModal'
import LocalHelper          from    './LocalHelper'
import LocalCentralButtons  from    './ChildComponents/LocalCentralButtons.vue'
import eventBus             from    '@/plugins/eventBus'

export default {

    name:   'PatnerFormModal',

    props: [
        'title',
        'rooms_length',
        'rest_api',
        'notyf',
        'bed_numbers',
        'array_options',
        'breadcrumb',
        'next_walking_number',
        'parent_id',
        'from_child',
        'parent',
        'save_view',
    ],

    mixins:[
        LocalHelper,
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        LocalCentralButtons,
    },

    data() {
        return {
            modal_name:         'static-patner',
            form_data:          ChildFormResources.patner_form_data,
            form_backup:        {...ChildFormResources.form_data},
            form_format:        ChildFormResources.form_format,
            form_format2:        ChildFormResources.form_format2,
            fixtures:           [],
            save_and_new:       true,
        }
    },

    watch:{

        async "form_data.floor_id"(val)
        {
            await this.defaultProjectTaskCoincidence(val, this.form_data.daily_task_id)
        },

        async "form_data.daily_task_id"(val)
        {
            await this.defaultProjectTaskCoincidence(this.form_data.floor_id, val)
        },

        "form_data.room_type_id"(val)
        {
            if(val)
            {
                this.form_data.fixtures = []
                
                const room_type = this.array_options['room_type_id'].find((data) => data.id === val)
                const patient = room_type.patient;
                this.form_data.floor_id = room_type.floor_id

                if(room_type.unit)
                {
                    for(let i = 0; i < room_type.unit; i++)
                    {
                        let concat_prefix = this.form_data.door_number === '' || this.form_data.door_number === null ? (i+1) : this.form_data.door_number
                        this.form_data.fixtures.push( { name: `${concat_prefix} ${this.bed_numbers[i]}` } )
                    }
                }

                if(patient)
                {
                  this.form_data.patient = true
                }
                else
                {
                  this.form_data.patient = false
                }

                if(room_type.task_id) 
                {
                    this.form_data.daily_task_id = room_type.task_id
                }
            }
        },

        async "form_data.area_id"(val)
        {
            if(val)
            {
                await this.get_next_walking_number(val)
            }
        },

        next_walking_number(val)
        {
            if(val)
            {
                this.form_data.walking_number = this.next_walking_number
                this.form_backup.walking_number = this.next_walking_number
            }
        },

        defaultDescription(val)
        {
            if(val)
            {
                if(this.form_data.description == '' || this.form_data.description.includes(this.array_options.area_id.find(value => value.id == this.form_data.area_id).name) || this.includes_areas())
                {
                    this.form_data.description = String(val)
                }
            }
        },
        
        parent(val)
        {
            if(val)
            {
                this.form_data.area_id = this.parent.area_id
            }
        },

    },

    methods:{

        async form_submit()
        {
            if(this.rooms_length >= 5)
            {
                return false
            }

            this.LoaderOnModalOff(this.modal_name)

            const response = await this.post(this.rest_api, this.form_data)
            
            if(response.status)
            {
                this.$emit('unshiftObject', response.data.data)
                eventBus.$emit('unshiftObject', true)

                if( this.save_and_new )
                {
                    this.form_data.cost_center_id       =   ''
                    this.form_data.door_number          =   ''
                    this.form_data.description          =   ''
                    this.form_data.patient              =   false
                    this.form_data.time_adjustment      =   ''
                    this.form_data.work_group           =   false
                    this.form_data.exclude_daily        =   false
                    this.form_data.exclude_project      =   false
                    this.form_data.closed                 =   false
                    this.form_data.essential_cleaning   =   false
                    this.form_data.notes                =   ''
                    if (this.form_data.area_id && !this.from_child)
                    {
                        await this.get_next_walking_number(this.form_data.area_id)
                    }  
                }
                else
                {
                    // this.form_data.area_id              =   ''
                    this.form_data.room_type_id         =   ''
                    this.form_data.cost_center_id       =   ''
                    this.form_data.door_number          =   ''
                    this.form_data.description          =   ''
                    this.form_data.walking_number       =   ''
                    this.form_data.sq_ft                =   ''
                    this.form_data.patient              =   false
                    this.form_data.time_adjustment      =   ''
                    this.form_data.work_group           =   false
                    this.form_data.exclude_daily        =   false
                    this.form_data.exclude_project      =   false
                    this.form_data.closed               =   false
                    this.form_data.essential_cleaning   =   false
                    this.form_data.notes                =   ''
                    this.form_data.fixtures             =   []
                    this.form_data.floor_id             =   ''
                    this.save_and_new                   =   true             
                }

                this.notyf.success(`Success!`)
            } 
            else
            {
                this.error_handling(response)
                this.LoaderOffModalOn(this.modal_name, false)
            }
        },

        fixtureIncrement()
        {
            if(this.form_data.fixtures.length < 6)
            {
                let number_position = this.form_data.fixtures.length
                let concat_prefix = this.form_data.door_number === '' || this.form_data.door_number === null ? (this.form_data.fixtures.length+1) : this.form_data.door_number
                this.form_data.fixtures.push( { name: `${concat_prefix} ${this.bed_numbers[number_position]}` } )
            }
        },

        fixtureDecrement()
        {
            if(this.form_data.fixtures.length > 0)
            {
                let index = (this.form_data.fixtures.length - 1)
                
                if(this.form_data.fixtures[index].name !== '')
                {
                    let confirmation = window.confirm('Are you sure to drop this field?')
                    if(confirmation)
                    {
                        this.form_data.fixtures.splice(index, 1)
                    }
                    return true
                }
                this.form_data.fixtures.splice(index, 1)
            }
        },

        includes_areas()
        {
            for (const area of this.array_options.area_id)
            {
                if(this.form_data.description.includes(area.name))
                {
                    return true
                }    
            }
            return false
        },

        set_fields(fields)
        {
            for (const key in fields) {
                this.form_data[key] = fields[key]
            }
        },

        save_and_view(event)
        {
            this.$emit('saveView', event)
        }
    },

    mounted()
    {
        eventBus.$on('saveAndNew', () => 
        {
            this.save_and_new = false
        })
    },

    computed:
    {
        defaultDescription()
        {
            let area = ''
            let room_type = ''
            if(this.form_data.area_id)
            {
                area = this.array_options.area_id.find(value => value.id == this.form_data.area_id).name
            }

            if(this.form_data.room_type_id)
            {
                room_type = this.array_options.room_type_id.find(value => value.id == this.form_data.room_type_id).abbrevation
            }
            return area + (room_type ? ` ${room_type}` : '') + (this.form_data.door_number ? ` ${this.form_data.door_number}` : '')
        },
    },
    
}
</script>
